import { useState, useEffect } from 'react'
import styles from './Toast.module.css'

export default function Toast({ message, type = 'success', isVisible, onClose, duration = 5000 }) {
    useEffect(() => {
        if (isVisible && duration > 0) {
            const timer = setTimeout(() => {
                onClose && onClose()
            }, duration)
            
            return () => clearTimeout(timer)
        }
    }, [isVisible, duration, onClose])

    if (!isVisible) return null

    return (
        <div className={`${styles.toast} ${styles[type]}`}>
            <div className={styles.toastContent}>
                <div className={styles.toastIcon}>
                    {type === 'success' && '✅'}
                    {type === 'error' && '❌'}
                    {type === 'warning' && '⚠️'}
                    {type === 'info' && 'ℹ️'}
                </div>
                <div className={styles.toastMessage}>
                    {message}
                </div>
                <button 
                    className={styles.closeButton}
                    onClick={onClose}
                    aria-label="Close notification"
                >
                    ✕
                </button>
            </div>
        </div>
    )
}